<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
  text-align: right;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <v-spacer></v-spacer>
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        รายการค่าใช้จ่าย
      </div>
      <v-spacer></v-spacer>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-layout column class="pt-5 d-flex justify-space-between">
      <v-data-table
        :headers="headers"
        :items="billIndex"
        :items-per-page="20"
        class="elevation-1"
        :search="search"
      >
        <template #item="{ item }">
          <tr>
            <!--<td>
             <span>
                {{ item.CREATED_AT | formatDate }}
              </span> 
            </td>-->
            <td>{{ item.INVOICE_ID }}</td>
            <!-- <td>
              {{ item.MEMO }}
            </td> -->
            <td>{{ item.PAID_NO_VAT | delimeter }}</td>
            <!-- <td></td> -->
            <td v-if="(item.ISVAT = 1)">
              {{
                ((item.PAID_NO_VAT * parseFloat(item.VAT_VALUE!= "" ? item.VAT_VALUE : 0)) / 100)
                  | delimeter
              }}
              ({{item.VAT_VALUE != "" ? item.VAT_VALUE : 0 }})
            </td>
            <td v-else>0</td>
            <td>{{ item.PAID_VAT | delimeter }}</td>
            <td v-if="(item.ISVAT2 = 1)">
              {{
                ((item.PAID_NO_VAT *
                  parseFloat(item.VAT_VALUE2 != "" ? item.VAT_VALUE2 : 0)) /
                  100)
                  | delimeter
              }}
              ({{ item.VAT_VALUE2 != "" ? item.VAT_VALUE2 : 0 }})
            </td>
            <td v-else>0</td>
            <!-- <td>{{ item.PAID_NO_VAT | delimeter }}</td> -->
            <!-- <td>{{ item.PROVIDER_NAME }}</td> -->
            <td>{{ item.ACTUAL_PAY | delimeter }}</td>
            <td>
              <p
                class="mt-3"
                v-if="item.INVOICE_ID != null && item.STATUS == 'PAID'"
                style="font-size: 16px; color: green"
              >
                ชำระเงินแล้ว
              </p>
              <p
                class="mt-3"
                v-else-if="
                  item.INVOICE_ID != null && item.STATUS == 'REQUESTED'
                "
                style="font-size: 16px; color: orange"
              >
                รอตรวจสอบ
              </p>
              <p class="mt-3" v-else style="font-size: 16px; color: red">
                ค้างชำระ
              </p>
            </td>

            <td>
              <span v-if="item.INVOICE_ID != null && item.STATUS == 'PAID'">
                <span>
                  <v-btn text class="mx-n1" @click="printDoc(item)">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </span>
                <span>
                  <v-btn text class="mx-n1" @click="downloadDoc(item)">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </span>
              </span>
              <span
                v-else-if="
                  item.INVOICE_ID != null && item.STATUS == 'REQUESTED'
                "
              >
                <v-btn
                  color="success"
                  disabled
                  class="mx-n1"
                  @click="paid(item)"
                >
                  <v-icon left>mdi-cash-multiple</v-icon>
                  ชำระเงิน
                </v-btn>
              </span>
              <div v-else>
                <v-btn color="success" class="mx-n1" @click="paid(item)">
                  <v-icon left>mdi-cash-multiple</v-icon>
                  ชำระเงิน
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialog"
        :persistent="this.payMethod == 'QRCODE'"
        max-width="550"
        @click:outside="closeModal()"
      >
        <v-card>
          <v-card-title
            class="text-h4 font-weight-black info--text text-spacing"
            color="blue"
          >
            เลือกช่องทางชำระเงิน
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-col
                cols="12"
                lg="12"
                class="mt-n1"
                style="justify-content: center"
              >
                <v-banner
                  elevation="1"
                  height="50"
                  color="grey lighten-4"
                  style="border: none"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      lg="6"
                      class="my-n2"
                      style="font-weight: bold"
                      >มูลค่าที่ต้องชำระ</v-col
                    >
                    <v-col
                      cols="12"
                      lg="6"
                      class="my-n2 text-right pl-5"
                      style="font-weight: bold"
                      >{{ price_to_pay | delimeter }} บาท</v-col
                    >
                  </v-row>
                </v-banner>
                <div class="flex-center">
                  <v-radio-group
                    row
                    class="mb-n10"
                    v-model="payMethod"
                    @change="payType()"
                  >
                    <v-radio
                      class="pr-6"
                      label="ชำระผ่าน QR-CODE"
                      hide-details
                      value="QRCODE"
                    ></v-radio>
                    <v-radio
                      class="pr-6"
                      label="โอน/ชำระผ่านบัญชีธนาคาร"
                      hide-details
                      value="NONQR"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="12" lg="12" v-if="payMethod == 'NONQR'">
                <v-row justify="center" v-if="stepPay == '1'">
                  <v-col cols="12" lg="11" class="mt-n3 mb-n3">
                    <v-radio-group
                      v-model="chooseAccount"
                      background-color="#ECEFF1"
                    >
                      <v-radio
                        v-for="(item, i) in account"
                        :key="i"
                        :value="item"
                        class="pa-3"
                      >
                        <template v-slot:label>
                          <div>
                            <div
                              class="font-weight-medium"
                              style="font-weight: bold !important"
                            >
                              {{ item.BANK }}
                            </div>
                            <div
                              class="font-weight-regular caption"
                              style="font-size: 14px !important"
                            >
                              ชื่อบัญชี ​: {{ item.ACCOUNT_NAME }}
                            </div>
                            <div
                              class="font-weight-regular caption"
                              style="font-size: 14px !important"
                            >
                              เลขที่บัญชี ​: {{ item.ACCOUNT_NUMBER }}
                            </div>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-btn color="primary" width="100%" @click="upload()">
                    อัพโหลดหลักฐานการชำระเงิน
                  </v-btn>
                </v-row>
                <v-row justify="center" v-else-if="stepPay == '2'">
                  <v-col cols="12" lg="11" class="mt-n11">
                    <v-row>
                      <v-col cols="12" lg="6" class="mt-10">
                        วันที่โอน:
                        <date-picker
                          :format="momentFormat"
                          v-model="transferDate"
                          class="custom-datepicker"
                          style="width: 150px"
                        ></date-picker>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-12">
                        เวลา :
                        <vue-timepicker
                          v-model="transferTime"
                          auto-scroll
                          close-on-complete
                          format="HH:mm"
                        ></vue-timepicker>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" lg="11" class="mt-n6 mb-n3">
                    โอนจากธนาคาร:
                    <v-autocomplete
                      v-model="fromBank"
                      :items="banks"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" lg="11" class="mt-n7 mb-n3">
                    <div v-if="!haveFile">
                      <v-file-input
                        prepend-icon=""
                        accept=".png, .jpg, .jpeg"
                        prepend-inner-icon="mdi-paperclip"
                        label="กดเพื่ออัพโหลดรูปหลักฐานการชำระเงิน"
                        outlined
                        dense
                        @change="onSelect"
                        class="mt-2"
                      ></v-file-input>
                    </div>
                    <div v-else>
                      <v-card>
                        <v-img :src="imgUrl" height="125" class="white"></v-img>
                        <v-layout style="justify-content: flex-end">
                          <v-btn @click="changeImg()" text>
                            {{ fileName }}<v-icon>mdi-close</v-icon></v-btn
                          >
                        </v-layout>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="11" class="mt-n8">
                    หมายเหตุ:
                    <v-textarea
                      outlined
                      dense
                      rows="3"
                      v-model="remark"
                    ></v-textarea>
                  </v-col>
                  <v-btn color="primary" width="100%" @click="sendData()">
                    ส่งข้อมูล
                  </v-btn>
                </v-row>
              </v-col>
              <!------------------------------ QR-CODE SECTION ------------------------------>
              <v-col cols="12" lg="12" v-else>
                <center>
                  <div v-if="loader_qr" style="height: 200px">
                    <v-progress-circular
                      style="top: 50%"
                      indeterminate
                      :size="50"
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-else class="mt-5">
                    <qrcode-vue :value="qr_payment" :size="200"></qrcode-vue>
                    <div>
                      <p :class="{ 'text-danger': total <= 0 }">
                        <strong>{{ minutes }}</strong>
                        <strong>:</strong>
                        <strong>{{ seconds }}</strong>
                      </p>
                    </div>
                  </div>
                </center>
                <v-btn color="primary" width="100%" @click="CancelQR()">
                  ยกเลิก
                </v-btn>
              </v-col>

              <!------------------------------ /////////////// ------------------------------>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import moment from "moment";
import printJS from "print-js";
import XLSX from "xlsx";
import { mapGetters, mapMutations, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
export default {
  name: "LinkCusBill",
  components: {
    QrcodeVue,
    VueTimepicker,
  },
  data: () => ({
    total: "",
    minutes: "--",
    seconds: "--",
    interval: 0,
    intervalCheckPayment: 0,
    passData: Array,
    search: "",
    qr_payment: "",
    ref_id_payment: "",
    loader_qr: false,
    remark: "",
    fromBank: "",
    transferTime: `${
      new Date().getHours() < 10
        ? "0" + new Date().getHours()
        : new Date().getHours()
    }:${
      new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes()
    }`,
    transferDate: new Date(),
    invoice_id: "",
    haveFile: false,
    price_to_pay: 0,
    dialog: false,
    radioGroup: 1,
    payMethod: "NONQR",
    chooseAccount: "",
    stepPay: "1",
    file: "",
    imgUrl: "",
    banks: [
      "กรุงเทพ จำกัด (มหาชน)",
      "กรุงไทย จำกัด (มหาชน)",
      "กรุงศรีอยุธยา จำกัด (มหาชน)",
      "กสิกรไทย จำกัด (มหาชน)",
      "ซีไอเอ็มบี ไทย จำกัด (มหาชน)",
      "ซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)",
      "ทหารไทย จำกัด (มหาชน)",
      "ทิสโก้ จำกัด (มหาชน)",
      "ไทยพาณิชย์ จำกัด (มหาชน)",
      "ธนชาต จำกัด (มหาชน)",
      "เมกะ สากลพาณิชย์ จำกัด (มหาชน)",
      "ยูโอบี จำกัด (มหาชน)",
      "แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)",
      "สแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)",
      "เอเอ็นแซด (ไทย) จำกัด (มหาชน)",
      "ไอซีบีซี (ไทย) จำกัด (มหาชน)",
      "ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)",
    ],
    headers: [
      // {
      //   text: "วันที่",
      //   align: "start",
      //   sortable: false,
      //   value: "CREATED_AT",
      // },
      { text: "เลขที่ใบเสร็จ", value: "INVOICE_ID" },
      // { text: "รายละเอียด", value: "CUSTOMER_NAME" },
      { text: "รวมจำนวนเงิน", value: "PAID_NO_VAT" },
      { text: "ภาษีมูลค่าเพิ่ม	", value: "PAID_VAT" },
      { text: "จำนวนรวม", value: "PAID_VAT" },
      { text: "ภาษีหักณ.ที่จ่าย", value: "ACTUAL_PAY" },
      { text: "จำนวนรวมทั้งสิ้น	", value: "ACTUAL_PAY" },
      { text: "สถานะ", value: "DOC_STATUS" },
      { text: "", value: "detail" },
    ],
    bill: [],
    account: [],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
  }),
  created() {
    this.transferTime = this.$store.commit("Quotation/SET_IS_EDIT", false);
  },
  computed: {
    billIndex() {
      console.log(this.bill);
      return this.bill.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  created() {
    const cus_id = this.$route.params.cus_id;
    this.list_bill(cus_id);
    this.list_account();
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      SET_STEP: "Drawer/SET_STEP",
      EDIT_BL: "Bill/SET_IS_EDIT",
      B_SET: "Bill/SET_ELEMENT",
      SET_ALL_BL: "Bill/SET_ALL_ELEMENT",
      B_SPLITING: "Bill/SET_SPLITING",
      B_MERGE: "Bill/MERGE_ALL_ELEMENT",
      B_SET_PRODUCT: "Bill/SET_PRODUCT_LIST",
    }),
    onSelect(file) {
      this.file = file;
    },
    list_account() {
      this.$token_api
        .get("/list-account")
        .then((response) => {
          this.account = response.data.data;
        })
        .catch((err) => {});
    },
    list_bill(cus_id) {
      this.$token_api
        .post("/list-customer-bill", { CUSTOMER_ID: cus_id })
        .then((response) => {
          this.bill = response.data.data;
        })
        .catch((err) => {});
    },
    printDoc(tbl_data) {
      this.LOADER(true);
      this.$download_api
        .get(`/donwload-invoice/${tbl_data.INVOICE_ID}`)
        .then((response) => {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              response.data,
              "ใบเสร็จ_" + tbl_data.INVOICE_ID + ".pdf"
            ); //IE is the worst!!!
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            printJS(url);
          }
          this.LOADER(false);
        })
        .catch((err) => {
          this.$swal({
            title: "เกิดข้อผิดพลาด",
            icon: "warning",
            text: "ไม่พบเอกสาร",
          });
          this.LOADER(false);
        });
    },
    downloadDoc(tbl_data) {
      this.LOADER(true);
      this.$download_api
        .get(`/donwload-invoice/${tbl_data.INVOICE_ID}`)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "ใบเสร็จ_" + tbl_data.INVOICE_ID + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
          this.LOADER(false);
        })
        .catch((err) => {
          this.$swal({
            title: "เกิดข้อผิดพลาด",
            icon: "warning",
            text: "ไม่พบเอกสาร",
          });
          this.LOADER(false);
        });
    },
    paid(item) {
      this.stepPay = "1";
      this.dialog = true;
      this.payMethod = "NONQR";
      this.price_to_pay = item.ACTUAL_PAY;
      this.invoice_id = item.INVOICE_ID;
    },
    closeModal() {
      // clearInterval(this.interval)
    },
    CancelQR() {
      this.cancelPayment(this.ref_id_payment);
      clearInterval(this.interval);
      clearInterval(this.intervalCheckPayment);
      this.dialog = false;
    },
    payType() {
      this.stepPay = "1";
      if (this.payMethod == "QRCODE") {
        this.loader_qr = true;
        this.$payment_api
          .post("/request_qr", {
            bill_id: this.invoice_id,
            merchant_id: "KB000001611672",
            amount: parseFloat(parseFloat(this.price_to_pay).toFixed(2)),
          })
          .then((response) => {
            let data = response.data;
            this.qr_payment = data.qr_code;
            this.ref_id_payment = data.ref_id;
            console.log(data.ref_id);
            this.intervalStart();
            this.loader_qr = false;
          })
          .catch((err) => {});
      } else {
        this.cancelPayment(this.ref_id_payment);
        clearInterval(this.interval);
        clearInterval(this.intervalCheckPayment);
        //this.CancelQR()
      }
    },
    intervalStart() {
      this.total = parseInt(60, 10);
      this.interval = setInterval(() => {
        this.tick();
      }, 1000);
      this.intervalCheckPayment = setInterval(() => {
        this.checkStatusPay(this.ref_id_payment);
      }, 10000);
    },
    str_pad_left(string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length);
    },
    checkStatusPay(ref_id) {
      console.log("checkstatus is working !!");
      this.$payment_api
        .post("/check_payment", { ref_id: ref_id })
        .then((response) => {
          let data = response.data;
          console.log(data.status);
          if (data.status == "PAID") {
            let insert_obj = {
              CUSTOMER_ID: this.$route.params.cus_id,
              PRICE: this.price_to_pay,
              PAY_TYPE: this.payMethod,
              REFERENCE1: this.invoice_id,
              REFERENCE2: ref_id,
            };
            this.$token_api
              .post("/insert-transaction-qrcode", insert_obj)
              .then((response) => {
                clearInterval(this.interval);
                clearInterval(this.intervalCheckPayment);
                this.dialog = false;
                this.list_bill(this.$route.params.cus_id);
              })
              .catch((err) => {
                this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (x == NaN) {
        x = 0;
      }
      return x;
    },
    tick() {
      console.log("clock is ticking !!");
      var minutes = Math.floor(this.total / 60);
      var seconds = this.total - minutes * 60;
      this.minutes = this.str_pad_left(minutes, "0", 2);
      this.seconds = this.str_pad_left(seconds, "0", 2);
      if (this.total <= 0) {
        clearInterval(this.interval);
        clearInterval(this.intervalCheckPayment);
        this.$swal({
          title: "สิ้นสุดระยะเวลาในการชำระเงิน",
          text: `กรุณาทำรายการใหม่อีกครั้ง`,
          icon: "warning",
          allowOutsideClick: false,
          confirmButtonText: "ตกลง",
        }).then((result) => {
          if (result) {
            this.dialog = false;
            this.cancelPayment(this.ref_id_payment);
          }
        });
      }
      this.total -= 1;
    },
    cancelPayment(ref_id) {
      this.$payment_api
        .post("/cancel_qr", { ref_id: ref_id })
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    upload() {
      let account_detail = this.chooseAccount;
      if (typeof account_detail == "object") {
        this.stepPay = "2";
      } else {
        this.$swal({
          title: "กรุณาเลือกบัญชีที่จะทำการโอน",
          icon: "warning",
          timer: 2500,
        });
      }
    },
    sendData() {
      this.LOADER(true);
      let date = new Date(this.transferDate);
      let time = this.transferTime;
      if (!this.fromBank) {
        this.$swal({
          title: "กรุณาเลือกธนาคาร",
          icon: "warning",
          timer: 2500,
        });
      } else if (!this.file) {
        this.$swal({
          title: "กรุณาอัพโหลดหลักฐานการชำระเงิน",
          icon: "warning",
          timer: 2500,
        });
      } else if (!time && !date) {
        this.$swal({
          title: "กรุณาเลือกวันเวลาที่โอน",
          icon: "warning",
          timer: 2500,
        });
      } else {
        date.setHours(time.split(":")[0]);
        date.setMinutes(time.split(":")[1]);
        let account_detail = this.chooseAccount;
        const cus_id = this.$route.params.cus_id;
        let nameOfFile = this.file.name;
        let array_last_name = nameOfFile.split(".");
        let file_lname = array_last_name[array_last_name.length - 1];
        let insert_obj = {
          CUSTOMER_ID: cus_id,
          DATE_PAID: date,
          PRICE: this.price_to_pay,
          FROM_BANK: this.fromBank,
          TO_BANK: account_detail.id,
          PAY_TYPE: this.payMethod,
          REFERENCE1: this.invoice_id,
          ADDTIONAL_INFO: this.remark,
        };
        this.$token_api
          .post("/insert-transaction-type2", insert_obj)
          .then((response) => {
            let transac_id = response.data.data.insertId;
            this.savefile(transac_id);
          })
          .catch((err) => {
            this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
            this.LOADER(false);
          });
      }
    },
    getImage() {
      this.$download_api
        .get(`/download-slip`)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          this.imgUrl = url;
          this.haveFile = true;
        })
        .catch((e) => {
          this.haveFile = false;
        });
    },
    savefile(tid) {
      const formData = new FormData();
      const cus_id = this.$route.params.cus_id;
      let file_attr = this.file;
      formData.set("transaction_id", tid);
      formData.set("cus_id", cus_id);
      formData.set("invoice_id", this.invoice_id);
      formData.append("files", this.file);

      this.$token_api
        .post("/upload-slip-img", formData)
        .then((res) => {
          if (res.data.data == "Upload success") {
            this.$swal({
              title: "สำเร็จ",
              text: "ส่งข้อมูลสำเร็จ",
              timer: 2000,
              icon: "success",
            }).then((res) => {
              const cus_id = this.$route.params.cus_id;
              this.getImage();
              this.dialog = false;
              this.list_bill(cus_id);
              this.LOADER(false);
            });
          }
        })
        .catch((e) => {
          this.$swal(
            "เกิดข้อผิดพลาดในการอัพโหลด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
        });
    },
  },
};
</script>